import {PolIcon} from "components/PolIcon/policon";
import React, {useEffect, useRef, useState} from 'react';
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";

export default function Notice({type, message, show, delay, closable = true}) {

    const [showNotice, setShowNotice] = useState(show)
    const [hideDelay, setHideDelay] = useState(delay);
    const timeoutRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);

    if (!hideDelay) setHideDelay(3);

    useEffect(() => setShowNotice(show), [show])

    useEffect(() => setHideDelay(delay), [delay])

    useEffect(() => {
        // Clear the previous timeout if it exists
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        if (!(showNotice && hideDelay > 0 && !isHovered)) return;

        timeoutRef.current = setTimeout(() => setShowNotice(false), hideDelay * 1000);

        return () => {
            if (!timeoutRef.current) return;

            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, [showNotice, hideDelay, isHovered])

    const handleMouseEnter = () => {
        setIsHovered(true);

        if (!timeoutRef.current) return;

        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
    };

    const handleMouseLeave = () => setIsHovered(false);

    return (
        <ToggleComponent isShowing={showNotice} shouldRemoveFromDom>
            <div className={`alertNotice alertNotice--${type}`}
                 onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave}>
                {closable &&
                    <PolIcon icon="close"
                             className="alertNotice__close"
                             onClick={() => setShowNotice(false)}/>}
                {typeof message === 'string' ? <p>{message}</p> : message}
            </div>
        </ToggleComponent>
    )

}
